import { useSavedWalletAddressApi } from 'BreetHooks';

import { DialogWithdrawUsdWalletAddressesSaved } from '../walletAddresses';
import FormWalletAddress from './wallet-address/Form.WalletAddress';

const FormDestination = () => {
	const { isSavedWalletAddressesEmpty } = useSavedWalletAddressApi();

	return (
		<div className='payment-request-form_usdDestination'>
			{isSavedWalletAddressesEmpty ? <FormWalletAddress /> : <DialogWithdrawUsdWalletAddressesSaved />}
		</div>
	);
};

export default FormDestination;
